"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.getTitleColor = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _backgrounds = require("./backgrounds.js");
var _assistants = require("./assistants.js");
var _controls = require("./controls.js");
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _image = _interopRequireDefault(require("cccisd-icons/image"));
var _cccisdColorPicker = _interopRequireWildcard(require("cccisd-color-picker"));
var _reactRedux = require("react-redux");
var _builder = require("../../selectors/builder.js");
var _cccisdSound = require("cccisd-sound");
var _RestrictionsLevelContext = _interopRequireDefault(require("../../other/RestrictionsLevelContext.js"));
var _BgPicker = _interopRequireDefault(require("./BgPicker"));
var _corner = _interopRequireDefault(require("./assets/corner.png"));
var _middle = _interopRequireDefault(require("./assets/middle.png"));
var _side = _interopRequireDefault(require("./assets/side.png"));
var _HeaderPreview = _interopRequireDefault(require("./HeaderPreview"));
var _NavigationPreview = _interopRequireDefault(require("./NavigationPreview"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _settings = _interopRequireDefault(require("./settings.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = ['title', 'pageTitle', 'pageTitleColor', 'pageDescription', 'pageDescriptionColor', 'navigationColor', 'prevButtonTitle', 'nextButtonTitle', 'completeButtonTitle', 'feedbackButtonTitle', 'prevSurveyButtonTitle', 'assistant', 'assistantPosition', 'assistantAvatar', 'showTitle', 'showPageTitleDescription', 'showInstructions', 'showProgressBar', 'useSegmentedProgressBar', 'showAudioToggle', 'showCalculator', 'showFullscreenToggle', 'showPrevButton', 'background', 'backgroundColor', 'backgroundImage', 'backgroundSize', 'height', 'elementStyle', 'controlStyle', 'elementFontSize', 'showStickyBottomBar', 'ttsVoice', 'scaleContent', 'askIfSkipped', 'skippedConfirmationText'];
var initialValues = exports.initialValues = {
  title: 'Title',
  pageTitle: 'Heading',
  pageTitleColor: 'primary',
  pageDescription: 'Instructions',
  pageDescriptionColor: '#ffffff',
  navigationColor: 'primary',
  prevButtonTitle: 'Back',
  nextButtonTitle: 'Next',
  completeButtonTitle: 'Complete',
  feedbackButtonTitle: 'Check answers',
  prevSurveyButtonTitle: 'Back',
  assistant: '',
  assistantPosition: 'side',
  assistantAvatar: {},
  showTitle: true,
  showPageTitleDescription: false,
  showInstructions: false,
  showProgressBar: true,
  useSegmentedProgressBar: false,
  showAudioToggle: false,
  showCalculator: false,
  showFullscreenToggle: false,
  showPrevButton: true,
  background: '',
  backgroundColor: '#c6daf3',
  backgroundImage: null,
  backgroundSize: 'cover',
  height: '',
  elementStyle: '',
  controlStyle: '',
  elementFontSize: 'normal',
  showStickyBottomBar: false,
  ttsVoice: null,
  scaleContent: false,
  askIfSkipped: false,
  skippedConfirmationText: 'At least one question was skipped. Would you like to proceed anyway?'
};
var assistantPositionOptions = [{
  label: 'Top corner',
  value: 'corner',
  thumbnail: _corner["default"]
}, {
  label: 'Side of screen',
  value: 'side',
  thumbnail: _side["default"]
}, {
  label: 'Middle of screen',
  value: 'middle',
  thumbnail: _middle["default"]
}];
var elementStyleOptions = [{
  label: 'Default',
  value: '',
  renderPickerItem: function renderPickerItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].customThumbnailWrapper + ' ' + _settings["default"].elementStyleWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", null, "Content"));
  }
}, {
  label: 'White outline',
  value: 'bubble',
  renderPickerItem: function renderPickerItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].customThumbnailWrapper + ' ' + _settings["default"].elementStyleWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].bubble
    }, "Content"));
  }
}];
var progressBarOptions = [{
  label: 'Default',
  value: '',
  renderPickerItem: function renderPickerItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].customThumbnailWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress",
      style: {
        width: '80%',
        marginBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar",
      style: {
        width: '60%'
      }
    })));
  }
}, {
  label: 'Segmented',
  value: 'segmented',
  renderPickerItem: function renderPickerItem() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].customThumbnailWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _settings["default"].segmentedProgressBar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress",
      style: {
        marginBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar",
      style: {
        width: '50%'
      }
    }))));
  }
}];
var elementFontSizeOptions = [{
  title: 'Small',
  value: 'small'
}, {
  title: 'Normal',
  value: 'normal'
}, {
  title: 'Large',
  value: 'large'
}, {
  title: 'Huge',
  value: 'huge'
}, {
  title: 'Enormous',
  value: 'enormous'
}];
var backgroundSizeOptions = [{
  label: 'Cover',
  value: 'cover'
}, {
  label: 'Scale',
  value: 'scale'
}, {
  label: 'Bottom',
  value: 'bottom'
}];
var protectedAssistants = ['ollie'];
var protectedBackgrounds = ['club'];

// Convert old colors to the new cccisd-color-picker colors
var convertTitleColor = function convertTitleColor(color) {
  var oldColors = {
    primary: 'primaryColor',
    success: 'successColor',
    info: 'infoColor',
    warning: 'warningColor',
    danger: 'dangerColor'
  };
  return color in oldColors ? oldColors[color] : color;
};
var getTitleColor = exports.getTitleColor = function getTitleColor(color) {
  return (0, _cccisdColorPicker.getColor)(convertTitleColor(color));
};
var validate = exports.validate = function validate(values) {
  var errors = {};
  return errors;
};
var Highlighted = function Highlighted(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].highlightedWrapper,
    style: props.style
  }, props.isHighlighted && /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].highlighted
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _settings["default"].body
  }, props.children));
};
var Settings = /*#__PURE__*/function (_React$Component) {
  _inherits(Settings, _React$Component);
  function Settings() {
    var _this;
    _classCallCheck(this, Settings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Settings, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "TextBlock", function (props) {
      return /*#__PURE__*/_react["default"].createElement(Highlighted, {
        isHighlighted: _this.props.highlightedFields.includes(props.field.name)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, props));
    });
    _defineProperty(_assertThisInitialized(_this), "Block", function (props) {
      return /*#__PURE__*/_react["default"].createElement(Highlighted, {
        isHighlighted: _this.props.highlightedFields.includes(props.field.name),
        style: props.style
      }, props.children);
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeBackground", function (e) {
      var _this$props$fields = _this.props.fields,
        background = _this$props$fields.background,
        backgroundColor = _this$props$fields.backgroundColor;
      var value = e.target.value;
      if (value === 'uploadedImage' && _this.uploadedImageModal) {
        _this.uploadedImageModal.open();
      }
      backgroundColor.onChange('#c6daf3');
      background.onChange(e);
    });
    return _this;
  }
  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$ttsVoiceO;
      var _this$props$fields2 = this.props.fields,
        title = _this$props$fields2.title,
        pageTitle = _this$props$fields2.pageTitle,
        pageTitleColor = _this$props$fields2.pageTitleColor,
        pageDescription = _this$props$fields2.pageDescription,
        pageDescriptionColor = _this$props$fields2.pageDescriptionColor,
        navigationColor = _this$props$fields2.navigationColor,
        prevButtonTitle = _this$props$fields2.prevButtonTitle,
        nextButtonTitle = _this$props$fields2.nextButtonTitle,
        completeButtonTitle = _this$props$fields2.completeButtonTitle,
        feedbackButtonTitle = _this$props$fields2.feedbackButtonTitle,
        prevSurveyButtonTitle = _this$props$fields2.prevSurveyButtonTitle,
        assistant = _this$props$fields2.assistant,
        assistantPosition = _this$props$fields2.assistantPosition,
        showTitle = _this$props$fields2.showTitle,
        showPageTitleDescription = _this$props$fields2.showPageTitleDescription,
        showInstructions = _this$props$fields2.showInstructions,
        showProgressBar = _this$props$fields2.showProgressBar,
        useSegmentedProgressBar = _this$props$fields2.useSegmentedProgressBar,
        showAudioToggle = _this$props$fields2.showAudioToggle,
        showCalculator = _this$props$fields2.showCalculator,
        showFullscreenToggle = _this$props$fields2.showFullscreenToggle,
        showPrevButton = _this$props$fields2.showPrevButton,
        showStickyBottomBar = _this$props$fields2.showStickyBottomBar,
        scaleContent = _this$props$fields2.scaleContent,
        background = _this$props$fields2.background,
        backgroundColor = _this$props$fields2.backgroundColor,
        height = _this$props$fields2.height,
        elementStyle = _this$props$fields2.elementStyle,
        controlStyle = _this$props$fields2.controlStyle,
        elementFontSize = _this$props$fields2.elementFontSize,
        backgroundImage = _this$props$fields2.backgroundImage,
        backgroundSize = _this$props$fields2.backgroundSize,
        ttsVoice = _this$props$fields2.ttsVoice,
        askIfSkipped = _this$props$fields2.askIfSkipped,
        skippedConfirmationText = _this$props$fields2.skippedConfirmationText;
      var inSidebar = this.props.inSidebar;
      var values = Object.keys(this.props.fields).reduce(function (obj, key) {
        obj[key] = _this2.props.fields[key].value;
        return obj;
      }, {});
      var restrictionsLevel = this.context;
      var adjustedAssistantOptions = _assistants.assistantOptions.filter(function (option) {
        return !protectedAssistants.includes(option.value) || option.value === assistant.value;
      });
      var adjustedBackgroundOptions = _backgrounds.backgroundOptions.filter(function (option) {
        return !protectedBackgrounds.includes(option.value) || option.value === background.value;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(inSidebar && _settings["default"].inSidebar)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Header",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].headerCheckboxesWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showTitle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showTitle))), ' ', "Show title"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showPageTitleDescription
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showPageTitleDescription))), ' ', "Show heading"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showInstructions
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showInstructions))), ' ', "Show instructions"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showCalculator
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showCalculator))), ' ', "Show calculator"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showAudioToggle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showAudioToggle))), ' ', "Show audio toggle"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showFullscreenToggle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showFullscreenToggle))), ' ', "Show fullscreen toggle", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Fullscreen toggle is not available when \u201CEntire page is scrollable\u201D is selected in the \u201CLayout & style\u201D section below."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))))), /*#__PURE__*/_react["default"].createElement(_HeaderPreview["default"], {
        settings: values
      })), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: title,
        label: "Title",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].pageTitleField
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: pageTitle,
        label: "Heading",
        isWysiwyg: true
      })), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: pageTitleColor,
        style: {
          zIndex: 21
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        label: "Heading color",
        field: pageTitleColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
        value: convertTitleColor(pageTitleColor.value),
        onChange: pageTitleColor.onChange
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].pageDescriptionField
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: pageDescription,
        label: "Instructions",
        isWysiwyg: true
      })), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: pageDescriptionColor,
        style: {
          zIndex: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        label: "Instructions color",
        field: pageDescriptionColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
        value: convertTitleColor(pageDescriptionColor.value),
        onChange: pageDescriptionColor.onChange
      }))))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Navigation",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].navigationCheckboxesWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showProgressBar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showProgressBar))), ' ', "Show progress bar"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showPrevButton
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(showPrevButton))), ' ', "Allow navigation to previous pages"))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: askIfSkipped
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-check-input",
        type: "checkbox"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(askIfSkipped))), ' ', "Ask for confirmation if question is skipped before advancing to next page")))), /*#__PURE__*/_react["default"].createElement(_NavigationPreview["default"], {
        settings: values
      })), askIfSkipped.value ? /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: skippedConfirmationText,
        label: "Skipped confirmation text"
      }) : null, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: navigationColor,
        style: {
          zIndex: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        wrapperClassName: "mt-3 mb-3",
        label: "Navigation color",
        field: navigationColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
        value: convertTitleColor(navigationColor.value),
        onChange: navigationColor.onChange
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].gridGap
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: controlStyle
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Button style")), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: controlStyle,
        options: _controls.controlOptions
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: useSegmentedProgressBar
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Progress bar style")), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: useSegmentedProgressBar,
        options: progressBarOptions,
        value: useSegmentedProgressBar.value ? 'segmented' : '',
        onChange: function onChange(value) {
          return useSegmentedProgressBar.onChange(value === 'segmented');
        }
      })))), /*#__PURE__*/_react["default"].createElement("h4", null, "Button Text"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].grid,
        style: {
          marginBottom: '-15px'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: prevButtonTitle,
        label: "Previous page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: nextButtonTitle,
        label: "Next page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: completeButtonTitle,
        label: "Complete last page",
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: prevSurveyButtonTitle,
        label: /*#__PURE__*/_react["default"].createElement("span", null, "Previous survey", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Previous survey button is shown when pressing the button would go to the previous survey in the Quest, which is possible in certain Quest navigation configurations."
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))),
        isWysiwyg: true
      }), /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: feedbackButtonTitle,
        label: /*#__PURE__*/_react["default"].createElement("span", null, "Check answers", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "The \"Next page\" button is replaced by \"Check answers\" when questions have correct answers and instant feedback is enabled."
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))),
        isWysiwyg: true
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Layout & Style",
        show: true,
        type: "primary"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: showStickyBottomBar
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: showStickyBottomBar,
        label: "When page contents are taller than available vertical space:"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].verticalOption + ' ' + _settings["default"].scrollable
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(_settings["default"].thumbnailWrapper, _defineProperty({}, _settings["default"].active, !showStickyBottomBar.value)),
        onClick: function onClick() {
          showStickyBottomBar.onChange(false);
          scaleContent.onChange(false);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].thumbnail
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].description
      }, "Entire page is scrollable", /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow,
        style: {
          marginLeft: '2em',
          marginTop: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(this.TextBlock, {
        field: height,
        label: /*#__PURE__*/_react["default"].createElement("span", null, "Minimum page height", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Minimum page height can be set to make sure the navigation bar is not too high on the page if content is very short."
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))),
        inputStyle: {
          width: 'auto'
        }
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].verticalOption + ' ' + _settings["default"].fixed
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(_settings["default"].thumbnailWrapper, _defineProperty({}, _settings["default"].active, showStickyBottomBar.value && !scaleContent.value)),
        onClick: function onClick() {
          showStickyBottomBar.onChange(true);
          scaleContent.onChange(false);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].thumbnail
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].description
      }, "Header and footer are fixed in place, contents inside are scrollable")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].verticalOption + ' ' + _settings["default"].scaled
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(_settings["default"].thumbnailWrapper, _defineProperty({}, _settings["default"].active, showStickyBottomBar.value && scaleContent.value)),
        onClick: function onClick() {
          showStickyBottomBar.onChange(true);
          scaleContent.onChange(true);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].thumbnail
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].description
      }, "Content is scaled down to fit")))), /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: elementFontSize
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: elementFontSize,
        label: "Font size for elements"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].fontSizeWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group",
        style: {
          marginRight: '15px'
        }
      }, elementFontSizeOptions.map(function (size) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          key: size.value,
          type: "button",
          className: "btn btn-secondary ".concat(elementFontSize.value === size.value && 'active'),
          onClick: function onClick() {
            return elementFontSize.onChange(size.value);
          }
        }, size.title);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_settings["default"].example, " ").concat(_settings["default"][elementFontSize.value])
      }, "Example text with this font size")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: background
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Background")), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: background,
        options: adjustedBackgroundOptions,
        onChange: function onChange(value) {
          if (value === background.value) {
            return;
          }
          if (value !== '') {
            elementStyle.onChange('bubble');
          }
          background.onChange(value);
        }
      }))), background.value === 'uploadedImage' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].uploadedImageBackground
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundImage
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.ImagePickerBlock, {
        value: backgroundImage.value,
        onChange: backgroundImage.onChange,
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _classnames4["default"])('btn btn-primary', backgroundImage.value && 'btn-sm')
        }, /*#__PURE__*/_react["default"].createElement(_image["default"], {
          spaceRight: true
        }), /*#__PURE__*/_react["default"].createElement("span", null, "Upload image"))
      }))), backgroundImage.value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: backgroundImage.value.name,
        src: backgroundImage.value.thumbnailSmall,
        width: "60px",
        style: {
          borderRadius: '5px'
        }
      })) : null), backgroundImage.value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundSize
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Background size")), /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(backgroundSize), {
        value: backgroundSize.value
      }), backgroundSizeOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))) : null), background.value === 'solidColor' && /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: backgroundColor,
        style: {
          zIndex: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        label: "Background color",
        field: backgroundColor
      }, /*#__PURE__*/_react["default"].createElement(_cccisdColorPicker["default"], {
        value: backgroundColor.value,
        onChange: backgroundColor.onChange
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: elementStyle
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Element style", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: 'Set Element style to "White outline" if the background image is too dark or complex for content to appear directly on it.'
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: elementStyle,
        options: elementStyleOptions
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: assistant
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Assistant", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "An Assistant is an animated character that can provide additional instructions or help during the survey taking process."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: assistant,
        options: adjustedAssistantOptions,
        thumbnailStyle: {
          aspectRatio: '1',
          backgroundSize: '90% 90%'
        }
      }))), assistant.value ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: assistantPosition
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Assistant position")), /*#__PURE__*/_react["default"].createElement(_BgPicker["default"], {
        field: assistantPosition,
        options: assistantPositionOptions
      }))) : null, restrictionsLevel !== 'basic' && /*#__PURE__*/_react["default"].createElement(this.Block, {
        field: ttsVoice
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Text-to-speech voice")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _settings["default"].voiceWrapper
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(ttsVoice), {
        value: ttsVoice.value || ((_this$props$ttsVoiceO = this.props.ttsVoiceOptions[0]) === null || _this$props$ttsVoiceO === void 0 ? void 0 : _this$props$ttsVoiceO.value),
        style: {
          width: 'auto'
        }
      }), this.props.ttsVoiceOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: function onClick() {
          var option = _this2.props.ttsVoiceOptions.find(function (item) {
            return item.value === ttsVoice.value;
          }) || _this2.props.ttsVoiceOptions[0];
          (0, _cccisdSound.play)(option.url);
        }
      }, /*#__PURE__*/_react["default"].createElement(_play["default"], null)))))));
    }
  }]);
  return Settings;
}(_react["default"].Component);
_defineProperty(Settings, "propTypes", {
  fields: _propTypes["default"].object,
  highlightedFields: _propTypes["default"].array,
  inSidebar: _propTypes["default"].bool
});
_defineProperty(Settings, "defaultProps", {
  highlightedFields: []
});
Settings.contextType = _RestrictionsLevelContext["default"];
var mapStateToProps = function mapStateToProps(state) {
  return {
    ttsVoiceOptions: (0, _builder.getLanguageVoices)(state.flow.builder)
  };
};
var ConnectedSettings = (0, _reactRedux.connect)(mapStateToProps)(Settings);
var _default = exports["default"] = (0, _cccisdSurveyCommon.templateSettingsWrapper)({
  fields: fields,
  validate: validate,
  initialValues: initialValues
})(ConnectedSettings);